import Navbar from "../Menu/Navbar";
import Footer from "./Sections/Footer";
import PageHeaderAllPage from "../../Components/layouts/PageHeaderAllPage";
import Blog1 from "../../Components/blogs/Blog1";
import Preloader from "../../Components/Preloader";
import { useTranslation } from "react-i18next";

const OurBranches = () => {
  const { t } = useTranslation();
  return (
    <>
      <Navbar type="internal" />
      <Preloader />
      <main className="main">
        <PageHeaderAllPage
          tone="brand"
          showMenu
          current={t("menu.ourBranches")}
          banner="assets/imgs/page-header/banner5.png"
          link="our-branches"
        />
        <section className="box-section-term background-body pt-85 pb-85">
          <Blog1 />
        </section>
      </main>
      <Footer type="external" />
    </>
  );
};

export default OurBranches;
